import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@screentone/addon-auth-wrapper';

import type { AtLeastOne } from 'types/helpers';
import { ROLE_TYPE } from './types';
import useRoles from './useRoles';

const useRequireRoles = (...requiredRoles: AtLeastOne<ROLE_TYPE>) => {
  const navigate = useNavigate();
  const isAllowed = useRoles(...requiredRoles);
  const { currentProperty } = useAuth();

  useEffect(() => {
    if (!isAllowed && currentProperty) {
      const path = `/${currentProperty}`;
      navigate(path);
    }
  }, [navigate, isAllowed, requiredRoles, currentProperty]);
};

export default useRequireRoles;
